import {sendWebsocketMessage} from '../../../../../../App'
/**
 * A feature of quick trade is that we guess whether the user wants to go long or short based on the direction 
 * of the current 1 min candle. This message requests that information
 * @param {*} symbol request symbol
 * @param {*} dataSource request datasource
 * @param {*} id id of message. this key will be sent back in order to identify the data you requested (as opposed to other requests for this kind of information)
 */
export function requestQuickTradeDirection(symbol, dataSource, id)
{
    const msg = {
        messageType: "quickTradeDirection",
        symbol: symbol,
        dataSource: dataSource,
        id: id
    }
    sendWebsocketMessage(msg);
}